var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLiveChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2493_10767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 190.476C1.15434 196.786 4.84419 200 10.3804 200C12.8164 200 14.4403 199.23 16.2627 197.959L37.3699 179.932C37.3699 179.932 116.334 180.784 122.49 179.932C128.647 179.08 131.672 175.944 132.179 170.068C132.415 167.329 132.431 149.853 132.381 131.973H132.179C120.373 131.293 114.15 129.915 103.805 125.51C94.4704 120.621 90.0539 117.158 83.0442 110.204C76.4501 102.115 73.2311 97.3352 69.5493 87.755C68.6098 84.9844 67.9078 82.6064 67.3738 80.2722H10.3804C3.54163 81.156 1.34357 83.3952 0 90.4762V190.476Z",
    fill: "#0075FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.798 80.2724C128.723 81.3548 131.062 83.5848 132.179 90.4762C132.179 90.4762 132.323 111.49 132.381 131.973H189.618C190.628 131.919 191.241 131.858 192.04 131.633C194.795 130.704 195.992 129.952 197.576 128.231C199.481 125.719 199.925 124.303 199.998 121.769V65.3062C199.833 58.254 199.175 54.6936 197.576 48.6396C194.899 39.7028 192.66 35.3388 187.888 28.2314C183.069 21.9148 180.165 18.6292 174.047 13.9456C169.004 10.3343 166.029 8.48366 160.206 5.78232C157.421 4.59844 155.84 3.9787 152.94 3.06144C145.358 1.02934 141.015 0.186014 132.871 0C122.611 0.270316 116.538 1.25476 104.498 6.1226C96.9284 10.148 93.035 12.5375 87.5426 17.347C81.2197 23.56 78.1621 27.1102 74.3939 33.6734C71.7367 38.7826 70.3908 41.7292 68.5117 47.279C66.4988 54.961 65.7739 59.2204 65.7434 66.6668C66.0236 72.2898 66.4449 76.2146 67.3737 80.2724H121.798Z",
    fill: "#0075FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2493_10767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLiveChat);
export default __webpack_public_path__ + "static/media/logoLiveChat.abddfbb589d072081211430c6e294eb5.svg";
export { ForwardRef as ReactComponent };